// mindmetal-app/web/src/hooks/useMindMetaLConfig.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@personic/shared'
import type { MindMetaLConfig, LLMProvider } from '@personic/shared'

const QUERY_KEYS = {
  config: ['mindmetal-config'],
  providers: ['mindmetal-providers'],
}

export function useMindMetaLConfig() {
  return useQuery({
    queryKey: QUERY_KEYS.config,
    queryFn: async () => {
      const { data } = await api.get<MindMetaLConfig>('/api/mindmetal/v3/admin/config')
      return data
    },
  })
}

export function useMindMetaLProviders() {
  return useQuery({
    queryKey: QUERY_KEYS.providers,
    queryFn: async () => {
      const { data } = await api.get<LLMProvider[]>('/api/mindmetal/v3/admin/providers')
      return data
    },
  })
}

export function useUpdateMindMetaLConfig() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (config: Partial<MindMetaLConfig>) => {
      const { data } = await api.put<MindMetaLConfig>('/api/mindmetal/v3/admin/config', config)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.config })
    },
  })
}
